'use strict';
import { NativeModules } from 'react-native';
const { RNSecLib } = NativeModules;

const commands = Object.freeze({
	start: 'start',
	stop: 'stop',
	logEvent: 'logEvent',
});

const keyNames = Object.freeze({
	commandName: 'command',
	timerName: 'timer_name',
	timerId: 'timer_id',
	timestamp: 'timestamp',
	eventPayload: 'event_payload',
});

export class AtomicInteger {
	_value = 0;

	constructor(initialValue = 0) {
		this._value = initialValue;
	}

	get value() {
		return this._value;
	}

	set value(newValue) {
		if (newValue) {
			this._value = newValue;
		}
	}

	incrementAndGet() {
		return ++this._value;
	}
}

class RemoteCommand {
	static timers = {};
	static nextId = new AtomicInteger(1000);
	static SMAPIRemoteCommand(commandDict) {
		const date = new Date();
		const command = commandDict[keyNames.commandName];
		if (!command) {
			return;
		}

		var timerId = commandDict[keyNames.timerId];
		if (!timerId || isNaN(timerId)) {
			timerId = null;
		}
		var timestampString = commandDict[keyNames.timestamp];
		var timestamp = null;

		if (timestampString) {
			timestamp = parseInt(timestampString, 10);
		} else {
			timestamp = date.getTime();
		}

		const commandArray = command.split(',');
		commandArray.forEach(commandTemp => {
			var trimmedCommand = commandTemp.trim();
			switch (trimmedCommand) {
				case commands.start: {
					RemoteCommand.startTimerCommand(commandDict, timerId, timestamp);
					break;
				}
				case commands.stop: {
					RemoteCommand.stopTimerCommand(commandDict, timerId, timestamp);
					break;
				}
				case commands.logEvent: {
					RemoteCommand.logEventCommand(commandDict);
					break;
				}
				default:
					return;
			}
		});
	}

	static startTimerCommand(commandDict, timerId, timestamp) {
		const timerName = commandDict[keyNames.timerName];
		if (timerName.toUpperCase() === 'APPLAUNCH') {
			return;
		}
		if (!timerName) {
			return;
		}
		// if an override timerId has been provided, then use that.
		if (timerId) {
			RemoteCommand.timers[timerName] = timerId;
		} else {
			RemoteCommand.timers[timerName] = RemoteCommand.nextId.incrementAndGet();
		}
		const timerIdFi = RemoteCommand.timers[timerName];
		console.log(`Starting Timer for timerName ${timerName} and timerId ${timerIdFi} at ${timestamp}`);
		RNSecLib.startTimer(timerName, timerIdFi, timestamp);
	}

	static stopTimerCommand(commandDict, timerId, timestamp) {
		const timerName = commandDict[keyNames.timerName];
		if (!timerName) {
			return;
		}
		if (timerName.toUpperCase() === 'APPLAUNCH') {
			RNSecLib.appDidLaunch(timestamp);
			return;
		}
		if (timerId === null) {
			timerId = RemoteCommand.timers[timerName];
			if (!timerId) {
				console.log(`No timerId provided and unknown timerId for timerName ${timerName}`);
				return;
			}
		}
		if (timestamp) {
			const timerIdFi = RemoteCommand.timers[timerName];
			console.log(`Stopping Timer for timerName ${timerName} and timerId ${timerId} at ${timestamp}`);
			RNSecLib.stopTimer(timerIdFi, timestamp);
		}
	}

	static logEventCommand(commandDict) {
		const eventPayload = commandDict[keyNames.eventPayload];
		if (eventPayload && typeof eventPayload === 'object') {
			console.log(`Event payload ${eventPayload}`);
			RNSecLib.logCustomEvent('NA', 'NA', 'NA', 'NA', eventPayload);
		}
	}
}

export const SMAPIRemoteCommand = RemoteCommand.SMAPIRemoteCommand;
